import _window from "@src/libraries/window";
import axios from "@src/libraries/axios";
import LocalStorage from "@src/libraries/LocalStorage";
import Vue from "@src/libraries/vue";
import swal from "@src/libraries/sweetalert";
import { i18n } from "@src/plugins/i18n";
import { moduleDebug } from "@src/assets/js/debug";
import { getPlatform, isMobile } from "@src/assets/js/device";
import { API_V2_URL, DOMContentLoaded, getScript, stringify, timeout, windowLoad } from "@src/assets/js/utils";
import { silentReport } from "@src/assets/js/report";
import usersStore from "@src/store/users";
import paymentStore from "@src/store/payment";
const IS_CORDOVA = !!_window._cordovaNative || !!_window._nativeReady;
const PLATFORM = getPlatform();
const IS_MOBILE = isMobile();
let PUSH_REGISTRATION = false;
const location = _window.location;
const matches = location && location.href.match(/referer=([^&]*)/);
if (matches && "string" == typeof matches[1]) {
    redirect(matches[1]);
}
const cordovaStore = new Vue({
    name: "CordovaStore",
    data() {
        const matches = location && location.href.match(/cordova=([^&]*)/);
        let simulateCordova = false;
        if (matches && "string" == typeof matches[1]) {
            simulateCordova = true;
        }
        const data = {
            simulateCordova,
            cordovaDetected: false,
            notCordovaDetected: false,
        };
        return data;
    },
    computed: {
        cordova() {
            const cordovaDetected = this.cordovaDetected;
            const simulateCordova = this.simulateCordova;
            return simulateCordova || cordovaDetected || !!IS_CORDOVA;
        },
        notCordova() {
            const notCordovaDetected = this.notCordovaDetected;
            return notCordovaDetected;
        },
    },
    asyncComputed: {
        version: {
            async get() {
                await deviceReady();
                const cordova = _window.cordova;
                return cordova && cordova.getAppVersion && cordova.getAppVersion.getVersionNumber();
            },
            default: ""
        },
        async cordovaPurchaseStore() {
            await deviceReady();
            await timeout(1);
            const store = _window.store;
            return !!store;
        },
    },
    watch: {
        me(me) {
            if (me) {
                pushNotification(me.id);
            }
        }
    },
    methods: {
        updateCordova(cordovaDetected) {
            this.cordovaDetected = cordovaDetected;
        },
        updateNotCordova(notCordovaDetected) {
            this.notCordovaDetected = notCordovaDetected;
        },
    }
});
export default cordovaStore;
moduleDebug(cordovaStore);
const document = _window.document;
document && document.addEventListener("deviceready", async function () {
    console.log("deviceready");
    cordovaStore.updateCordova(true);
    const universalLinks = _window.universalLinks;
    if (universalLinks) {
        universalLinks.subscribe("launchedAppFromLink", function (eventData) {
            let url = eventData.url;
            console.log("cordova universalLinks", url);
            url = url.replace(/api\/app\/?\?platform=(.*?)&path=/, "");
            redirect(url);
        });
        universalLinks.subscribe("qcart", eventData => {
            window.location.href = eventData.url.replace(/qcart\:\/\//, "https://");
        });
    }
    await DOMContentLoaded();
    await windowLoad();
    cordovaStoreInit();
    pushNotification();
});
function cordovaInject() {
    if (!process.client)
        return;
    if (!IS_MOBILE) {
        cordovaStore.updateNotCordova(true);
        return;
    }
    let src = "//injection/cordova.js";
    const location = _window.location;
    if (location && "comoquiero.abc" == location.hostname) {
        src = "http://localhost:8000/cordova.js";
    }
    getScript(src)
        .catch(async () => {
        await windowLoad();
        if (!_window.cordova)
            cordovaStore.updateNotCordova(true);
    });
}
cordovaInject();
export function deviceReady() {
    return new Promise(function (resolve) {
        const document = _window.document;
        if (document) {
            document.addEventListener("deviceready", function () {
                resolve();
            });
        }
        const cordova = _window.cordova;
        if (cordova)
            resolve();
    });
}
function redirect(url) {
    console.log("cordova redirect", url);
    if (!url || "string" != typeof url) {
        return;
    }
    const pathArr = url.match(/(?:http[s]?:\/\/)?(?:[^\/\s]+)?\/?(\/?.*)/i);
    const path = pathArr && pathArr[1];
    if (path) {
        console.log("cordova path", path);
        const location = _window.location;
        if (location) {
            location.replace("/" + path);
        }
    }
}
function pushNotification(userId) {
    userId = userId || (usersStore.me ? usersStore.me.id : undefined);
    const doPush = true;
    const PushNotification = _window.PushNotification;
    if (!PushNotification || !doPush) {
        console.log("!PushNotification || !doPush", !!PushNotification, !!doPush);
        return;
    }
    console.log("cordova push init");
    const push = PushNotification.init({
        android: {
            senderID: 956432534015,
            icon: "alpha",
            iconColor: "#f79436"
        },
        ios: {
            alert: "true",
            badge: "true",
            sound: "false"
        },
        windows: {}
    });
    push.on("registration", async (data) => {
        console.log("cordova push registration", stringify(data));
        if (PUSH_REGISTRATION)
            return;
        PUSH_REGISTRATION = true;
        const device = data.registrationId;
        if (!device)
            return;
        try {
            await axios.post(API_V2_URL + "/pushNotifications/cordova?failsafe", {
                device,
                platform: PLATFORM
            });
        }
        catch (e) {
            return;
        }
        LocalStorage.setItem("pushNotification", "" + userId);
    });
    push.on("notification", (data) => {
        console.log("cordova push notification", data);
        if (data.additionalData.url) {
            console.log("URL: " + data.additionalData.url);
            const location = _window.location;
            if (location) {
                location.href = data.additionalData.url;
            }
        }
    });
    push.on("error", (e) => {
        console.log("cordova push error", e.message, e);
        silentReport(e, { userId });
    });
}
async function cordovaStoreInit() {
    await timeout(1);
    const store = _window.store;
    if (!store)
        return;
    store.verbosity = store.DEBUG;
    store.error(function (err) {
        if (6777002 == err.code) {
        }
        else {
            const msg = err.message || "cordova store error";
            silentReport(msg, { err, order: store.order });
        }
        if (usersStore.paymentsTester)
            alert("store.error: " + JSON.stringify(err));
        paymentStore.ignoreSubscription = true;
    });
    const allSubscriptions = [
        "subscription",
        "month_suscription",
        "month_subscription",
        "quarterly_subscription",
        "semiannual_subscription",
        "annual_subscription",
        "month_subscription_50",
        "quarterly_subscription_50",
        "semiannual_subscription_50",
        "annual_subscription_50"
    ];
    for (const id of allSubscriptions) {
        store.register({
            id,
            type: "paid subscription"
        });
    }
    store.validator = async function (order, callback) {
        console.log("store.validator", order);
        const check = await checkCordovaPayment(order);
        check && callback(check, order);
    };
    store.when("order").owned(async function (order) {
        console.log("order owned", order);
        updateOrder(order);
    }).approved(function (order) {
        console.log("order approved", order);
        order.transaction ? order.finish() : order.verify();
        updateOrder(order);
    }).verified(function (order) {
        console.log("order verified", order);
        order.finish();
    }).refunded(function (order) {
        console.log("order refunded", { order });
        swal(i18n.t("reimbursed_payment") || "Pago reintegrado", "", "warning");
    }).cancelled(function (order) {
        console.log("order cancelled", { order });
        if (order.owned)
            return;
        swal(i18n.t("payment_canceled") || "Pago cancelado", "", "warning");
    }).updated(function (order) {
        if (usersStore.paymentsTester)
            alert("store.updated: " + JSON.stringify(order));
    });
    store.refresh();
}
;
function updateOrder(order) {
    console.log("order", order.state, order);
    paymentStore.paid();
    order.transaction && updateCordovaPayment(order);
}
async function checkCordovaPayment(order) {
    const me = usersStore.me;
    if (!me) {
        if (false === me)
            usersStore.login();
        return false;
    }
    if (!order || !order.transaction) {
        silentReport("checkCordovaPayment() !order || !order.transaction");
        return false;
    }
    const alreadySubscribed = await paymentStore.subscribedUserId(me.id);
    if (alreadySubscribed)
        return true;
    const payment = await updateCordovaPayment(order);
    if (!payment)
        return false;
    await paymentStore.reset();
    return true;
}
async function updateCordovaPayment(order) {
    let platform = getPlatform();
    if (!order || !order.transaction) {
        silentReport("updateCordovaPayment() !order || !order.transaction");
        return;
    }
    if ("ios-appstore" == order.transaction.type) {
        platform = "ios";
    }
    try {
        const response = await axios.post(API_V2_URL + "/payments/" + platform + "?failsafe", order);
        return response.data;
    }
    catch (e) {
        silentReport(e, { platform, order });
    }
}
;
